export enum AdditionalDocumentsRequestStatus {
  NotRequested = 'NOT_REQUESTED',
  Requested = 'REQUESTED',
  RequestedNoPayments = 'REQUESTED_NO_PAYMENTS',
  RequestedNoPayouts = 'REQUESTED_NO_PAYOUTS',
  RequestedNoPaymentsOrPayout = 'REQUESTED_NO_PAYMENTS_OR_PAYOUTS',
}
